const Religion = () => {
  const RelligoionData = [
    { value: "Buddhism", label: "Buddhism" },
    { value: "Christianity", label: "Christianity" },
    { value: "Hinduism", label: "Hinduism" },
    { value: "Islam", label: "Islam" },
    { value: "Judaism", label: "Judaism" },
    { value: "Sikhism", label: "Sikhism" },
    { value: "Bahá'í Faith", label: "Bahá'í Faith" },
    { value: "Jainism", label: "Jainism" },
    { value: "Shinto", label: "Shinto" },
    { value: "Taoism", label: "Taoism" },
    { value: "Zoroastrianism", label: "Zoroastrianism" },
    { value: "Druze", label: "Druze" },
    { value: "Rastafarianism", label: "Rastafarianism" },
    {
      value: "Traditional African Religions",
      label: "Traditional African Religions",
    },
    {
      value: "Indigenous Religions",
      label: "Indigenous Religions",
    },
    { value: "Atheism", label: "Atheism" },
    { value: "Agnosticism", label: "Agnosticism" },
    {
      value: "Spiritual but not religious",
      label: "Spiritual but not religious",
    },
    { value: "Other", label: "Other" },
  ];
  const NationalityData = [
    { value: "Afghan", label: "Afghan" },
    { value: "Albanian", label: "Albanian" },
    { value: "Algerian", label: "Algerian" },
    { value: "American", label: "American" },
    { value: "Andorran", label: "Andorran" },
    { value: "Angolan", label: "Angolan" },
    { value: "Argentine", label: "Argentine" },
    { value: "Armenian", label: "Armenian" },
    { value: "Australian", label: "Australian" },
    { value: "Austrian", label: "Austrian" },
    { value: "Azerbaijani", label: "Azerbaijani" },
    { value: "Bahraini", label: "Bahraini" },
    { value: "Bangladeshi", label: "Bangladeshi" },
    { value: "Barbadian", label: "Barbadian" },
    { value: "Belgian", label: "Belgian" },
    { value: "Belizean", label: "Belizean" },
    { value: "Beninese", label: "Beninese" },
    { value: "Bhutanese", label: "Bhutanese" },
    { value: "Bolivian", label: "Bolivian" },
    { value: "Bosnian", label: "Bosnian" },
    { value: "Brazilian", label: "Brazilian" },
    { value: "British", label: "British" },
    { value: "Bruneian", label: "Bruneian" },
    { value: "Bulgarian", label: "Bulgarian" },
    { value: "Burkinabe", label: "Burkinabe" },
    { value: "Burmese", label: "Burmese" },
    { value: "Burundian", label: "Burundian" },
    { value: "Cambodian", label: "Cambodian" }, ///cambodian
    { value: "Cameroonian", label: "Cameroonian" },
    { value: "Canadian", label: "Canadian" },
    { value: "Chadian", label: "Chadian" },
    { value: "Chilean", label: "Chilean" },
    { value: "Chinese", label: "Chinese" },
    { value: "Colombian", label: "Colombian" },
    { value: "Congolese", label: "Congolese" },
    { value: "Costa Rican", label: "Costa Rican" },
    { value: "Croatian", label: "Croatian" },
    { value: "Cuban", label: "Cuban" },
    { value: "Cypriot", label: "Cypriot" },
    { value: "Czech", label: "Czech" },
    { value: "Danish", label: "Danish" },
    { value: "Djiboutian", label: "Djiboutian" },
    { value: "Dominican", label: "Dominican" },
    { value: "Dutch", label: "Dutch" },
    { value: "Ecuadorian", label: "Ecuadorian" },
    { value: "Egyptian", label: "Egyptian" },
    { value: "Emirati", label: "Emirati" },
    { value: "English", label: "English" },
    { value: "Estonian", label: "Estonian" },
    { value: "Ethiopian", label: "Ethiopian" },
    { value: "Fijian", label: "Fijian" },
    { value: "Filipino", label: "Filipino" },
    { value: "Finnish", label: "Finnish" },
    { value: "French", label: "French" },
    { value: "Gabonese", label: "Gabonese" },
    { value: "Gambian", label: "Gambian" },
    { value: "Georgian", label: "Georgian" },
    { value: "German", label: "German" },
    { value: "Ghanaian", label: "Ghanaian" },
    { value: "Greek", label: "Greek" },
    { value: "Grenadian", label: "Grenadian" },
    { value: "Guatemalan", label: "Guatemalan" },
    { value: "Guinean", label: "Guinean" },
    { value: "Haitian", label: "Haitian" },
    { value: "Honduran", label: "Honduran" },
    { value: "Hungarian", label: "Hungarian" },
    { value: "Icelandic", label: "Icelandic" },
    { value: "Indian", label: "Indian" },
    { value: "Indonesian", label: "Indonesian" },
    { value: "Iranian", label: "Iranian" },
    { value: "Iraqi", label: "Iraqi" },
    { value: "Irish", label: "Irish" },
    { value: "Israeli", label: "Israeli" },
    { value: "Italian", label: "Italian" },
    { value: "Jamaican", label: "Jamaican" },
    { value: "Japanese", label: "Japanese" },
    { value: "Jordanian", label: "Jordanian" },
    { value: "Kazakh", label: "Kazakh" },
    { value: "Kenyan", label: "Kenyan" },
    { value: "Kuwaiti", label: "Kuwaiti" },
    { value: "Lao", label: "Lao" },
    { value: "Latvian", label: "Latvian" },
    { value: "Lebanese", label: "Lebanese" },
    { value: "Libyan", label: "Libyan" },
    { value: "Lithuanian", label: "Lithuanian" },
    { value: "Malagasy", label: "Malagasy" },
    { value: "Malaysian", label: "Malaysian" },
    { value: "Malian", label: "Malian" },
    { value: "Maltese", label: "Maltese" },
    { value: "Mexican", label: "Mexican" },
    { value: "Mongolian", label: "Mongolian" },
    { value: "Moroccan", label: "Moroccan" },
    { value: "Nepalese", label: "Nepalese" },
    { value: "Nigerian", label: "Nigerian" },
    { value: "Norwegian", label: "Norwegian" },
    { value: "Omani", label: "Omani" },
    { value: "Pakistani", label: "Pakistani" },
    { value: "Palestinian", label: "Palestinian" },
    { value: "Panamanian", label: "Panamanian" },
    { value: "Peruvian", label: "Peruvian" },
    { value: "Polish", label: "Polish" },
    { value: "Portuguese", label: "Portuguese" },
    { value: "Qatari", label: "Qatari" },
    { value: "Romanian", label: "Romanian" },
    { value: "Russian", label: "Russian" },
    { value: "Saudi", label: "Saudi" },
    { value: "Serbian", label: "Serbian" },
    { value: "Singaporean", label: "Singaporean" },
    { value: "Slovak", label: "Slovak" },
    { value: "South African", label: "South African" },
    { value: "South Korean", label: "South Korean" },
    { value: "Spanish", label: "Spanish" },
    { value: "Sri Lankan", label: "Sri Lankan" },
    { value: "Sudanese", label: "Sudanese" },
    { value: "Swedish", label: "Swedish" },
    { value: "Syrian", label: "Syrian" },
    { value: "Tunisian", label: "Tunisian" },
    { value: "Turkish", label: "Turkish" },
    { value: "Ukrainian", label: "Ukrainian" },
    { value: "Uruguayan", label: "Uruguayan" },
    { value: "Venezuelan", label: "Venezuelan" },
    { value: "Vietnamese", label: "Vietnamese" },
    { value: "Yemeni", label: "Yemeni" },
  ];
  const NationalityData2 = [
    { value: "Afghan", label: "Afghan" },
    { value: "Albanian", label: "Albanian" },
  ];
  const Paymenthod = [
    { value: "Bank", label: "Bank" },
    { value: "Cash", label: "Cash" },
  ];
  const Permissions = [
    { value: "Limited", label: "Limited" },
    { value: "Fully Control", label: "Fully Control" },
    { value: "Restricted", label: "Restricted" },
  ];
  const days: string[] = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  const reasonsToRecalculate = [
    {
      title: "Changes in clock-in or clock-out times",
      description: "If an employee has corrected their time entries or submitted missing punches.",
    },
    {
      title: "Manual adjustments",
      description: "When a manager adds, removes, or modifies time entries.",
    },
    {
      title: "Schedule changes",
      description: "If the employee’s shift schedule has been updated after the initial timesheet was calculated.",
    },
    {
      title: "Leave approvals or cancellations",
      description: "When vacation, sick leave, or other paid time off is applied or revoked.",
    },
    {
      title: "Policy updates",
      description: "When company rules (e.g., overtime calculation, rounding rules) have changed and need to be reflected in the timesheet.",
    },
    {
      title: "Error correction",
      description: "If the system failed to calculate totals correctly or a technical issue occurred.",
    },
  ];

  const reasonsToRecalculateLeave = [
    {
      title: "Recalculate Leave Quotas According to Attendance and Policy Updates",
    },
    {
      title: "Adjust Employee Leave Entitlements Based on Revised Data",
    },
    {
      title: "Systematic Recalculation of Annual Leave Balances",
    },
    {
      title: "Leave Entitlement Review and Adjustment",
    },
    {
      title: "Refresh and Reallocate Leave Based on Employment Records",
    },
  ];
  return { RelligoionData, NationalityData, days, reasonsToRecalculate, NationalityData2, Paymenthod, Permissions, reasonsToRecalculateLeave };
};
export default Religion;
